<div class="announcements-totals-per-customer">
  <h3>Number Of Published Announcements/Customer</h3>
  <div class="row">
    <div class="col-md-3">
      <div style="margin-top: 1em">
        <hr-date-range-picker
          class="date-picker"
          [dateFormat]="specialDateFormat"
          [style]="{ width: '100%', 'min-width': '5em' }"
          [(ngModel)]="announcementsTotalsPerCustomerFilter.dateRange"
        ></hr-date-range-picker>
      </div>
    </div>
    <div class="col-md-2">
      <div style="margin-top: 1em">
        <span>{{ 'label.GroupBy' | translate }}</span>
        <span style="margin-top: 0.5em">
          <select [(ngModel)]="announcementsTotalsPerCustomerFilter.group">
            <option [ngValue]="DateEnum.day">
              {{ 'label.Day' | translate }}
            </option>
            <option [ngValue]="DateEnum.week">
              {{ 'label.Week' | translate }}
            </option>
            <option [ngValue]="DateEnum.month">
              {{ 'label.Month' | translate }}
            </option>
            <option [ngValue]="DateEnum.year">
              {{ 'label.Year' | translate }}
            </option>
          </select>
        </span>
      </div>
    </div>
    <div class="col-md-2">
      <div style="margin-top: 1em">
        <span>{{ 'label.Website' | translate }}</span>
        <span>
          <select
            [(ngModel)]="announcementsTotalsPerCustomerFilter.providerWebsiteId"
          >
            <option [ngValue]="null">All</option>
            <option
              *ngFor="let item of providerWebsiteList"
              [ngValue]="item.value"
            >
              {{ item.text }}
            </option>
          </select>
        </span>
      </div>
    </div>
  </div>
  <div style="margin-top: 2em">
    <button (click)="applyFilter()">{{ 'label.Filter' | translate }}</button>
  </div>
  <div style="margin-top: 2em">
    <div *ngIf="announcementsTotalPerCustomerListModel?.list.length == 0">
      {{ 'message.NoRecordsFound' | translate }}
    </div>
    <table
      *ngIf="
        announcementsTotalPerCustomerListModel?.list.length != 0 &&
        announcementsTotalPerCustomerListModel != null
      "
      class="published-announcements-list"
    >
      <thead>
        <tr>
          <th>
            {{ 'label.CustomerName' | translate }}
            <!--<sort-button *ngIf="isSortedByField('customer')"
                          (onDownClicked)="orderByField('customer',false)"
                          (onUpClicked)="orderByField('customer',true)">
            </sort-button>-->
          </th>
          <th
            *ngFor="
              let groupHeader of announcementsTotalPerCustomerListModel?.groupHeaders;
              let i = index
            "
          >
            {{ groupHeader }}
            <!--<sort-button *ngIf="isSortedByGroup(i)"
                          (onDownClicked)="orderByGroup(i,false)"
                          (onUpClicked)="orderByGroup(i,true)">
            </sort-button>-->
          </th>
          <th>
            {{ 'label.Total' | translate }}
            <!--<sort-button *ngIf="isSortedByField('total')"
                          (onDownClicked)="orderByField('total',false)"
                          (onUpClicked)="orderByField('total',true)">
            </sort-button>-->
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of announcementsTotalPerCustomerListModel?.list">
          <td class="customer">
            <a [routerLink]="['/customers/view', item.head.customerId]">
              {{ item.head.customer }}
            </a>
          </td>
          <td *ngFor="let group of item.groups">
            {{ group.amount }}
          </td>
          <td class="sum-column">
            {{ item.head.total }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
